import {CardTitle} from '@hconnect/uikit/src/lib2'
import {Dialog, DialogContent} from '@mui/material'
import {Moment} from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useSelectedScheduleItemId} from '../../../../../../shared/components/providers/SelectedScheduleItemProvider'
import {useHistoryStoragesByIdQuery} from '../../../../../../shared/hooks/api'
import {useScheduleItem} from '../../../../../../shared/hooks/api/schedules/useScheduleItem'
import {useCurrentScheduleQuery} from '../../../../../../shared/hooks/api/schedules/useCurrentScheduleQuery'
import {useAssetHistoryDataByScheduleItemId} from '../../../../../../shared/hooks/api/useAssetHistoryDataByScheduleItemId'
import {Comment} from '../../../../../../shared/interfaces/api'

import {EditScheduleItemForm} from './EditScheduleItemForm'

export interface EditScheduleItemProps {
  startOfPlan: Moment
  endOfPlan: Moment
  commentsByItemId?: Record<string, Comment>
}

export const EditScheduleItemDialog: React.FC<EditScheduleItemProps> = ({
  startOfPlan,
  endOfPlan,
  commentsByItemId
}) => {
  const {t} = useTranslation()
  const {scheduleItemId, setScheduleItemId} = useSelectedScheduleItemId()
  const {data: schedule} = useCurrentScheduleQuery({range: [startOfPlan, endOfPlan]})
  const historyAssetsByItemId = useAssetHistoryDataByScheduleItemId({
    schedule,
    timeFrame: [startOfPlan, endOfPlan]
  })

  const {data: storagesById} = useHistoryStoragesByIdQuery({
    timeFrame: [startOfPlan, endOfPlan],
    throwOnError: false
  })
  const {data: scheduleItem} = useScheduleItem({id: scheduleItemId, startOfPlan, endOfPlan})
  if (!scheduleItem || !historyAssetsByItemId || !storagesById) return null
  const comment = commentsByItemId?.[scheduleItem.id]
  const assetName = historyAssetsByItemId[scheduleItem.id].asset.name

  return (
    <Dialog
      open={!!scheduleItem}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return
        }
        setScheduleItemId(undefined)
      }}
      fullWidth
    >
      <DialogContent>
        <CardTitle>{t('planning.planAsset', {asset: assetName})}</CardTitle>
        <EditScheduleItemForm
          scheduleItem={scheduleItem}
          startOfPlan={startOfPlan}
          endOfPlan={endOfPlan}
          comment={comment}
          assetData={historyAssetsByItemId[scheduleItem.id]}
          storagesById={storagesById}
        />
      </DialogContent>
    </Dialog>
  )
}
